/* eslint-disable import/no-unresolved */
const axios = require("axios");

function paramsToString(params) {
  const stringParams = { ...params };
  Object.keys(params).forEach((param) => {
    stringParams[param] = Array.isArray(params[param])
      ? params[param].join(",")
      : params[param];
  });
  return stringParams;
}

function abstractResource(serviceName) {
  const service = serviceName ? `VUE_APP_${serviceName}_API` : "VUE_APP_API";
  return (resourcePath) => {
    return {
      baseUrl: process.env[service],
      url: `${process.env[service]}${resourcePath}/`,
      request({
        params = {},
        headers = {},
        data = {},
        method = "get",
        url = this.url,
        ...axiosConfig
      } = {}) {
        return axios({
          method,
          url,
          headers,
          data,
          params: paramsToString(params),
          ...axiosConfig,
        })
          .then((response) => {
            return response.data;
          })
          .catch((error) => {
            console.error(error);
            throw error;
          });
      },
      async get({ params = {}, headers = {}, ...axiosConfig } = {}) {
        const { count, results, stats } = await this.request({
          headers,
          params,
          ...axiosConfig,
        }).catch((error) => {
          throw error;
        });
        return [results, count, stats];
      },
      async list({ params = {}, headers = {}, ...axiosConfig } = {}) {
        const { results } = await this.request({
          params,
          headers,
          ...axiosConfig,
        }).catch((error) => {
          throw error;
        });
        return results;
      },
      getById(id, { params = {}, headers = {}, ...axiosConfig } = {}) {
        return this.request({
          url: this.url + id + "/",
          headers,
          params,
          ...axiosConfig,
        });
      },
      create(data = {}, { params = {}, headers = {}, ...axiosConfig } = {}) {
        return this.request({
          method: "post",
          params,
          data,
          headers,
          ...axiosConfig,
        });
      },
      delete(id, { data = {}, params = {}, ...axiosConfig } = {}) {
        return this.request({
          method: "delete",
          url: this.url + id + "/",
          params,
          data,
          ...axiosConfig,
        });
      },
      edit(id, { data = {}, params = {}, ...axiosConfig } = {}) {
        return this.request({
          method: "put",
          url: this.url + id + "/",
          params,
          data,
          ...axiosConfig,
        });
      },
      patch(
        id,
        { data = {}, params = {}, partial = false, ...axiosConfig } = {}
      ) {
        for (const key in data) {
          if (data[key] === null && !partial) {
            delete data[key];
          }
          if (typeof data[key] === "string") {
            if (data[key].includes(".s3.amazonaws.com/media/private/")) {
              delete data[key];
            }
          }
        }
        return this.request({
          method: "patch",
          url: this.url + id + "/",
          params,
          data,
          ...axiosConfig,
        });
      },
    };
  };
}

module.exports = {
  abstractResource,
};
